import { render, staticRenderFns } from "./CoreWarningModal.vue?vue&type=template&id=1b107d1b&scoped=true&"
import script from "./CoreWarningModal.vue?vue&type=script&lang=js&"
export * from "./CoreWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./CoreWarningModal.vue?vue&type=style&index=0&id=1b107d1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b107d1b",
  null
  
)

export default component.exports